<template>
  <div>
    <SlideTop />
    <Categories />
    <Brands />
    <About />
    <Stores />
  </div>
</template>

<script>
import SlideTop from "./SlideTop.vue";
import Categories from "./Categories.vue";
import Stores from "./Stores.vue";
import Brands from "./Brands.vue";
import About from "./About.vue";
export default {
  components: { SlideTop, Categories, Stores, Brands, About },
};
</script>
